import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

const categories = [
  {
    year: '1',
    title: 'Long_Term_Transport_Contracts',
    description: 'Structured_Corporate_Agreements',
    icon: 'streamline-ultimate:business-contract-give',
  },
  {
    year: '2',
    title: 'Truck_Leasing',
    description: 'Flexible_Leasing_Programs',
    icon: 'mdi:contract-outline',
  },
  {
    year: '3',
    title: 'Port_Container_Transportation',
    description: 'Integrated_Port_Logistics_Services',
    icon: 'guidance:port',
  },
  {
    year: '4',
    title: 'Cross_Border_Land_Transportation',
    description: 'Regulated_and_Insured_Transport',
    icon: 'icon-park-outline:transporter',
  },
  {
    year: '5',
    title: 'Corporate_Account_Management',
    description: 'Dedicated_account_management_with_onsite_coordinators',
    icon: 'streamline-ultimate:delivery-package-person',
  },
  {
    year: '6',
    title: 'System_Integration',
    description: 'Enhance_Operational_Decision_Making',
    icon: 'oui:integration-general',
  },
  {
    year: '7',
    title: 'Fixed_Pricing_for_Defined_Routes',
    description: 'Service_that_offers_contract_based_fixed_pricing',
    icon: 'tabler:lock-dollar',
  },
  {
    year: '8',
    title: 'Cargo_Insurance_and_Proof_Management',
    description: 'Comprehensive_cargo_insurance_with_digital_proof_of_delivery',
    icon: 'mdi:package-variant-closed-check',
  },
  {
    year: '9',
    title: 'Automated_Trip_Pricing',
    description: 'Faster_Operational_Decision_Making',
    icon: 'mdi:currency-usd-circle-outline',
  },
];

export function BusinessSolutions({ sx, ...other }) {
  const { t } = useLocale();
  return (
    <Box
      component="section"
      sx={[
        {
          pb: { md: 10, xs: 5 },
          pt: { xs: 5, md: 10 },
          bgcolor: 'background.whitePaper',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Typography variant="h2" sx={{ textAlign: 'center', fontSize: '2rem !important' }}>
          {t('Business_Solutions')}
        </Typography>

        <Typography
          sx={{ my: 2, mx: 'auto', maxWidth: 800, color: 'text.secondary', textAlign: 'center' }}
        >
          {t('Business_Solutions_Description')}
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gap: { xs: 3, md: 5 },
            my: { xs: 2, md: 5 },
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
          }}
        >
          {categories?.map((category, index) => (
            <CategoryItem key={index} category={category} />
          ))}
        </Box>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------

function CategoryItem({ category }) {
  const { t } = useLocale();
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        px: 1,
        py: 3,
        minWidth: 1,
        borderRadius: 2,
        display: 'flex',
        // aspectRatio: '1/1',
        textAlign: 'center',
        position: 'relative',
        alignItems: 'center',
        bgcolor: 'transparent',
        flexDirection: 'column',
        justifyContent: 'center',
        transition: theme.transitions.create(['all']),
        '&:hover': {
          bgcolor: 'background.paper',
          boxShadow: theme.vars.customShadows.z24,
          '& .icon': {
            color: 'common.white',
            bgcolor: 'primary.main',
            transition: theme.transitions.create(['all']),
          },
        },
      })}
    >
      <Box
        className="icon"
        component="span"
        sx={{
          p: 2,
          mb: 1,
          display: 'flex',
          borderRadius: '50%',
        }}
      >
        <Iconify icon={category?.icon} sx={{ width: 40, height: 40 }} />
      </Box>

      <Typography variant="h6" sx={{ px: 3, width: 1, textWrap: 'auto' }}>
        {t(category?.title)}
      </Typography>

      <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
        {t(category?.description)}
      </Typography>
    </Paper>
  );
}
